<template>
  <div class="ra-auth">
    <div class="ra-auth--nav">
      <router-link :to="{ name: 'login' }">
        <img :src="getImage('logo.png')" alt="Radius" />
      </router-link>
      <div>
        <p>{{ view.text || "" }}</p>
        <a
          v-if="view.route.includes('http')"
          :href="view.route"
          target="_blank"
          >{{ view.label }}</a
        >
        <router-link v-else :to="{ name: view.route || 'login' }">{{
          view.label || ""
        }}</router-link>
      </div>
    </div>
    <div class="ra-auth--body">
      <div class="ra-auth--body__form">
        <router-view />
      </div>
      <div class="ra-auth--body__image fadeIn">
        <img :src="getImage(illustration)" alt="Identity Verification" />
      </div>
      <div class="ra-auth--body__copyright">
        <p>{{ year }} © <a href="https://radius.africa">Radius</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  computed: {
    illustration() {
      return this.$route.name === "error"
        ? "error.svg"
        : "auth-page--image.svg";
    },
    view() {
      const views = {
        login: {
          text: "New here?",
          label: "Create an Account",
          route: "register"
        },
        register: {
          text: "Already have an account?",
          label: "Continue",
          route: "login"
        },
        "forgot-password": {
          text: "",
          label: "Go to Login",
          route: "login"
        },
        "verify-otp": {
          text: "",
          label: "Back to Login",
          route: "login"
        },
        "update-password": {
          text: "",
          label: "",
          route: "login"
        },
        invite: {
          text: "Learn more about",
          label: "Radius",
          route: "https://staging.radius.africa"
        },
        error: {
          text: "Can't find page?",
          label: "Go Home",
          route: "home.index"
        }
      };

      const { name } = this.$route;
      return views[name] ? views[name] : views.login;
    },
    year() {
      return new Date().getFullYear();
    }
  }
};
</script>

<style lang="scss">
.ra-auth {
  height: 100%;
  width: 100%;
  padding: 40px;
  background: var(--ra-white);
  position: relative;

  > * {
    max-width: 1024px;
    margin: 0 auto;
  }

  &--nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    margin-bottom: 80px;

    img {
      height: 42px;
      width: auto;
    }

    div {
      display: flex;
      align-items: center;

      p {
        line-height: 1;
        margin-right: 5px;
        font-size: 0.875rem;
      }

      a {
        color: var(--ra-red-primary);
        font-size: 0.875rem;
      }
    }
  }

  &--body {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__form {
      background: var(--ra-white);
      width: 450px;
      padding: 40px;
      border-radius: 12px;
      -webkit-box-shadow: 0 0 80px 0 rgb(77 84 124 / 9%);
      box-shadow: 0 0 80px 0 rgb(77 84 124 / 9%);

      .ra-auth--form__header {
        margin-bottom: 30px;

        h1 {
          font-size: 1.35rem;
        }

        p {
          color: var(--ra-grey-tertiary);
        }
      }

      .el-input {
        &__inner {
          background-color: var(--ra-input-bg);
          border-color: var(--ra-input-bg);
          border-radius: 6px;
          height: 45px;
          color: var(--ra-grey-primary);
          font-family: "Source Sans Pro", sans-serif;
          font-size: 1rem;
          font-weight: 600;
          transition: border-color 0.25s ease-in;

          &:hover {
            border-color: var(--ra-input-border);
            transition: border-color 0.25s ease-out;
          }

          &:focus {
            border-color: var(--ra-input-border);
            transition: border-color 0.25s ease-out;
          }
        }

        &__prefix {
          left: 10px;

          i {
            position: relative;
            top: 2px;
          }
        }
      }

      .ra-auth--form__actions {
        display: flex;
      }
    }

    &__image {
      img {
        height: 350px;
        width: auto;
      }
    }

    &__copyright {
      position: absolute;
      bottom: -50px;
    }
  }
}

@media (max-width: 1024px) {
  .ra-auth {
    &--body {
      flex-direction: column-reverse;

      &__image {
        margin-bottom: 40px;
        img {
          height: 250px;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .ra-auth {
    padding: 40px 20px;

    &--nav {
      img {
        height: 24px;
      }

      div p {
        display: none;
      }
    }

    &--body {
      &__form {
        padding: 40px 20px;
        width: 100%;
      }

      &__image {
        display: none;
      }
      &__content {
        width: 100%;
      }
    }
  }
}

@media (max-width: 300px) {
  .oz-auth--form__footer {
    display: flex;
    flex-direction: column;
    align-items: center;

    button {
      margin-top: 10px;
    }
  }
}
</style>
